import { useCallback } from 'react'
import type { MouseEvent, MutableRefObject } from 'react'
import { useHistory } from 'react-router-dom'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useTranslate } from 'lib/tolgee'
import { ZAI_CHAT_PARAMS_KEY } from 'modules/zai/common/zai.consts'
import { PanelStore } from 'stores'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import { translations } from './zai-background-notification.i18n'
import type { TSwitchToThread } from './zai-background-notification.types'
import { createZaiBackgroundNotificationContent } from './zai-background-notification.utils'

export const useZaiBackgroundNotification = (
  switchToThreadRef: MutableRefObject<TSwitchToThread | undefined>,
  isChatVisible: () => boolean
) => {
  const { createToast, deleteToastById } = useToast()
  const history = useHistory()
  const t = useTranslate()

  const notifyBackgroundThreadComplete = useCallback(
    (threadId: string, title: string) => {
      const workspaceId = Object(PanelStore?.selectedPanel)?.panelId
      const link = `${getRoute(PATHNAMES.WORKSPACE_ZAI, { panelId: workspaceId })}?${ZAI_CHAT_PARAMS_KEY.threadId}=${threadId}`

      const goToThread = () => {
        switchToThreadRef.current?.(threadId)

        if (isChatVisible()) return

        history.push(link)
      }

      const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        deleteToastById(threadId)
      }

      createToast({
        id: threadId,
        content: createZaiBackgroundNotificationContent({
          title,
          message: t(translations.zaiToast),
          onGoToThread: goToThread,
          onClose: handleClose,
        }),
      })
    },
    [createToast, deleteToastById, history, isChatVisible, switchToThreadRef, t]
  )

  return { notifyBackgroundThreadComplete }
}
